// stole from https://youtu.be/o_Tf3tRk8bw
export const sample = {
    "items": {
        "669ee938a0f78": {
            "id": "669ee938a0f78",
            "renderType": "relay-item",
            "_valueIn": false,
            "_valueOut": false,
            "_holdTime": 2,
            "_prevRead": false,
            "_activateTime": 1,
            "_deactivateTime": 1,
            "x": 180,
            "y": 80,
            "inputs": [
                "5c8dcf6dd28d"
            ],
            "outputs": [
                "a64320de414c1"
            ]
        },
        "e1d1d04125a92": {
            "id": "e1d1d04125a92",
            "renderType": "relay-item",
            "_valueIn": false,
            "_valueOut": true,
            "_holdTime": 9,
            "_prevRead": false,
            "_activateTime": 12,
            "_deactivateTime": 12,
            "x": 180,
            "y": 180,
            "inputs": [
                "4f4d8d1f20491"
            ],
            "outputs": [
                "8e0ee94fbb332"
            ]
        },
        "00dcd0408f484": {
            "id": "00dcd0408f484",
            "renderType": "relay-item",
            "_valueIn": true,
            "_valueOut": true,
            "_holdTime": 5,
            "_prevRead": true,
            "_activateTime": 4,
            "_deactivateTime": 4,
            "x": 180,
            "y": 280,
            "inputs": [
                "aa3c0f8bc602a"
            ],
            "outputs": [
                "8aa76b8295232"
            ]
        },
        "40d0434220edb": {
            "id": "40d0434220edb",
            "renderType": "relay-item",
            "_valueIn": true,
            "_valueOut": true,
            "_holdTime": 5,
            "_prevRead": true,
            "_activateTime": 6,
            "_deactivateTime": 6,
            "x": 180,
            "y": 380,
            "inputs": [
                "d2bbaeb180a09"
            ],
            "outputs": [
                "337bebc239f86"
            ]
        },
        "f381bb15718aa": {
            "id": "f381bb15718aa",
            "renderType": "relay-item",
            "_valueIn": false,
            "_valueOut": false,
            "_holdTime": 7,
            "_prevRead": false,
            "_activateTime": 6,
            "_deactivateTime": 6,
            "x": 180,
            "y": 480,
            "inputs": [
                "2d68c2bd86a7f"
            ],
            "outputs": [
                "54518073d26eb"
            ]
        },
        "a3935eab533fc": {
            "id": "a3935eab533fc",
            "renderType": "sound-item",
            "x": 420,
            "y": 80,
            "_value": true,
            "_channel": 0,
            "_note": 38,
            "_velocity": 64,
            "_prevState": true,
            "inputs": [
                "05bb0144d6d3e"
            ],
            "outputs": []
        },
        "58cd9f9f78e76": {
            "id": "58cd9f9f78e76",
            "renderType": "sound-item",
            "x": 420,
            "y": 180,
            "_value": false,
            "_channel": 0,
            "_note": 45,
            "_velocity": 64,
            "_prevState": false,
            "inputs": [
                "d698c269c5104"
            ],
            "outputs": []
        },
        "deb0fb2bdf7d4": {
            "id": "deb0fb2bdf7d4",
            "renderType": "sound-item",
            "x": 420,
            "y": 280,
            "_value": false,
            "_channel": 0,
            "_note": 43,
            "_velocity": 64,
            "_prevState": false,
            "inputs": [
                "40bc67a721131"
            ],
            "outputs": []
        },
        "804ef13aae202": {
            "id": "804ef13aae202",
            "renderType": "sound-item",
            "x": 420,
            "y": 380,
            "_value": false,
            "_channel": 0,
            "_note": 41,
            "_velocity": 64,
            "_prevState": false,
            "inputs": [
                "c3a914bb4b8e"
            ],
            "outputs": []
        },
        "4f48fef9dc9fb": {
            "id": "4f48fef9dc9fb",
            "renderType": "sound-item",
            "x": 420,
            "y": 480,
            "_value": false,
            "_channel": 0,
            "_note": 40,
            "_velocity": 64,
            "_prevState": false,
            "inputs": [
                "b3e859e01f3b6"
            ],
            "outputs": []
        },
        "498dca0690fed": {
            "id": "498dca0690fed",
            "renderType": "output-pulse-item",
            "_value": false,
            "_persistTime": 12,
            "_buffer": false,
            "_hold": 0,
            "x": 60,
            "y": 80,
            "inputs": [],
            "outputs": [
                "4a61797d7ca5e"
            ]
        },
        "03074c67d0978": {
            "id": "03074c67d0978",
            "renderType": "relay-item",
            "_valueIn": false,
            "_valueOut": false,
            "_holdTime": 5,
            "_prevRead": false,
            "_activateTime": 4,
            "_deactivateTime": 4,
            "x": 180,
            "y": 580,
            "inputs": [
                "8659582adcb46"
            ],
            "outputs": [
                "b6b647d4ab603"
            ]
        },
        "c4043dab5cfba": {
            "id": "c4043dab5cfba",
            "renderType": "sound-item",
            "x": 420,
            "y": 580,
            "_value": false,
            "_channel": 0,
            "_note": 41,
            "_velocity": 64,
            "_prevState": false,
            "inputs": [
                "5cf29ab445a47"
            ],
            "outputs": []
        },
        "f2053a7d0b396": {
            "id": "f2053a7d0b396",
            "renderType": "relay-item",
            "_valueIn": false,
            "_valueOut": true,
            "_holdTime": 9,
            "_prevRead": false,
            "_activateTime": 12,
            "_deactivateTime": 12,
            "x": 300,
            "y": 80,
            "inputs": [
                "27f6664bb2255"
            ],
            "outputs": [
                "eb76a6f98b51d"
            ]
        },
        "0441e563f318a": {
            "id": "0441e563f318a",
            "renderType": "relay-item",
            "_valueIn": true,
            "_valueOut": false,
            "_holdTime": 9,
            "_prevRead": true,
            "_activateTime": 12,
            "_deactivateTime": 4,
            "x": 300,
            "y": 180,
            "inputs": [
                "aab783678826c"
            ],
            "outputs": [
                "1f0fb08f7a4bc"
            ]
        },
        "d052ea558cc4e": {
            "id": "d052ea558cc4e",
            "renderType": "relay-item",
            "_valueIn": true,
            "_valueOut": false,
            "_holdTime": 5,
            "_prevRead": true,
            "_activateTime": 12,
            "_deactivateTime": 6,
            "x": 300,
            "y": 280,
            "inputs": [
                "2fb599b757e6"
            ],
            "outputs": [
                "d5216ce904697"
            ]
        },
        "a90631dbff0e8": {
            "id": "a90631dbff0e8",
            "renderType": "relay-item",
            "_valueIn": false,
            "_valueOut": false,
            "_holdTime": 13,
            "_prevRead": false,
            "_activateTime": 12,
            "_deactivateTime": 6,
            "x": 300,
            "y": 380,
            "inputs": [
                "f6cdc3e77c8fa"
            ],
            "outputs": [
                "b234572956dbd"
            ]
        },
        "da590f5558ee2": {
            "id": "da590f5558ee2",
            "renderType": "relay-item",
            "_valueIn": false,
            "_valueOut": false,
            "_holdTime": 13,
            "_prevRead": false,
            "_activateTime": 12,
            "_deactivateTime": 4,
            "x": 300,
            "y": 480,
            "inputs": [
                "cbd997a1d7f9c"
            ],
            "outputs": [
                "bb2cd7b3e6812"
            ]
        },
        "692846d2a0d3c": {
            "id": "692846d2a0d3c",
            "renderType": "relay-item",
            "_valueIn": false,
            "_valueOut": false,
            "_holdTime": 13,
            "_prevRead": false,
            "_activateTime": 12,
            "_deactivateTime": 12,
            "x": 300,
            "y": 580,
            "inputs": [
                "393be4b09c19b"
            ],
            "outputs": [
                "3943cbb442a3d"
            ]
        },
        "dfb7ea3ae7cf2": {
            "id": "dfb7ea3ae7cf2",
            "renderType": "relay-item",
            "_valueIn": false,
            "_valueOut": false,
            "_holdTime": 13,
            "_prevRead": false,
            "_activateTime": 12,
            "_deactivateTime": 12,
            "x": 180,
            "y": 680,
            "inputs": [
                "65a73684139e8"
            ],
            "outputs": [
                "a7635a600850d"
            ]
        },
        "72746e72fb4b2": {
            "id": "72746e72fb4b2",
            "renderType": "relay-item",
            "_valueIn": false,
            "_valueOut": false,
            "_holdTime": 13,
            "_prevRead": false,
            "_activateTime": 12,
            "_deactivateTime": 4,
            "x": 300,
            "y": 680,
            "inputs": [
                "cf42ff6f2ce6d"
            ],
            "outputs": [
                "844b11297c186"
            ]
        },
        "7d8be5d948a9": {
            "id": "7d8be5d948a9",
            "renderType": "relay-item",
            "_valueIn": false,
            "_valueOut": false,
            "_holdTime": 13,
            "_prevRead": false,
            "_activateTime": 12,
            "_deactivateTime": 6,
            "x": 300,
            "y": 780,
            "inputs": [
                "fc0af6146be49"
            ],
            "outputs": [
                "6d250fc6b7a14"
            ]
        },
        "675bddddbc778": {
            "id": "675bddddbc778",
            "renderType": "relay-item",
            "_valueIn": false,
            "_valueOut": false,
            "_holdTime": 7,
            "_prevRead": false,
            "_activateTime": 6,
            "_deactivateTime": 6,
            "x": 180,
            "y": 780,
            "inputs": [
                "88f0cf30bc5ac"
            ],
            "outputs": [
                "01756de81c7b3"
            ]
        },
        "f4109dfe5c6b6": {
            "id": "f4109dfe5c6b6",
            "renderType": "sound-item",
            "x": 420,
            "y": 780,
            "_value": false,
            "_channel": 0,
            "_note": 40,
            "_velocity": 64,
            "_prevState": false,
            "inputs": [
                "6c65701497e65"
            ],
            "outputs": []
        },
        "24e5b918987e5": {
            "id": "24e5b918987e5",
            "renderType": "sound-item",
            "x": 420,
            "y": 680,
            "_value": false,
            "_channel": 0,
            "_note": 43,
            "_velocity": 64,
            "_prevState": false,
            "inputs": [
                "5cb94f8999dcc"
            ],
            "outputs": []
        },
        "181357c349a6f": {
            "id": "181357c349a6f",
            "renderType": "sound-item",
            "x": 420,
            "y": 880,
            "_value": false,
            "_channel": 0,
            "_note": 36,
            "_velocity": 64,
            "_prevState": false,
            "inputs": [
                "dd52414a1d17f"
            ],
            "outputs": []
        },
        "b5e6a327fc03e": {
            "id": "b5e6a327fc03e",
            "renderType": "relay-item",
            "_valueIn": false,
            "_valueOut": false,
            "_holdTime": 12,
            "_prevRead": false,
            "_activateTime": 12,
            "_deactivateTime": 6,
            "x": 300,
            "y": 880,
            "inputs": [
                "1343cdac0573"
            ],
            "outputs": [
                "355b7c7c17c77"
            ]
        },
        "cb72dcd168404": {
            "id": "cb72dcd168404",
            "renderType": "relay-item",
            "_valueIn": false,
            "_valueOut": false,
            "_holdTime": 10,
            "_prevRead": false,
            "_activateTime": 9,
            "_deactivateTime": 9,
            "x": 180,
            "y": 880,
            "inputs": [
                "09c52312f1787"
            ],
            "outputs": [
                "aa038e2c40a01"
            ]
        },
        "93b300a5d078a": {
            "id": "93b300a5d078a",
            "renderType": "and-item",
            "_valueIn1": true,
            "_valueIn2": false,
            "_valueOut": false,
            "_holdTime": 3,
            "_prevRead": false,
            "_activateTime": 2,
            "_deactivateTime": 2,
            "x": 60,
            "y": 280,
            "inputs": [
                "8a527d9dd8359",
                "191696fbd1218"
            ],
            "outputs": [
                "d84dca9612d0a"
            ]
        },
        "c6b4d19b2b82c": {
            "id": "c6b4d19b2b82c",
            "renderType": "output-item",
            "_value": true,
            "x": 60,
            "y": 180,
            "inputs": [],
            "outputs": [
                "a671c50c09fb3"
            ]
        }
    },
    "docks": {
        "5c8dcf6dd28d": {
            "id": "5c8dcf6dd28d",
            "type": "input",
            "owner": "669ee938a0f78",
            "links": [
                "daba81b2ac665",
                "9d0149678c7ec"
            ],
            "$type": "dock-relay-input"
        },
        "a64320de414c1": {
            "id": "a64320de414c1",
            "type": "output",
            "owner": "669ee938a0f78",
            "links": [
                "f47bb8815f6b3",
                "b3fa07c723451"
            ],
            "$type": "dock-relay-output"
        },
        "4f4d8d1f20491": {
            "id": "4f4d8d1f20491",
            "type": "input",
            "owner": "e1d1d04125a92",
            "links": [
                "f47bb8815f6b3"
            ],
            "$type": "dock-relay-input"
        },
        "8e0ee94fbb332": {
            "id": "8e0ee94fbb332",
            "type": "output",
            "owner": "e1d1d04125a92",
            "links": [
                "471ed071bb0a9",
                "a0787676b6cc8"
            ],
            "$type": "dock-relay-output"
        },
        "aa3c0f8bc602a": {
            "id": "aa3c0f8bc602a",
            "type": "input",
            "owner": "00dcd0408f484",
            "links": [
                "471ed071bb0a9"
            ],
            "$type": "dock-relay-input"
        },
        "8aa76b8295232": {
            "id": "8aa76b8295232",
            "type": "output",
            "owner": "00dcd0408f484",
            "links": [
                "f3ca871321591",
                "34ff9e72cd016"
            ],
            "$type": "dock-relay-output"
        },
        "d2bbaeb180a09": {
            "id": "d2bbaeb180a09",
            "type": "input",
            "owner": "40d0434220edb",
            "links": [
                "f3ca871321591"
            ],
            "$type": "dock-relay-input"
        },
        "337bebc239f86": {
            "id": "337bebc239f86",
            "type": "output",
            "owner": "40d0434220edb",
            "links": [
                "8c09edf7806eb",
                "7e0625d5030f3"
            ],
            "$type": "dock-relay-output"
        },
        "2d68c2bd86a7f": {
            "id": "2d68c2bd86a7f",
            "type": "input",
            "owner": "f381bb15718aa",
            "links": [
                "8c09edf7806eb"
            ],
            "$type": "dock-relay-input"
        },
        "54518073d26eb": {
            "id": "54518073d26eb",
            "type": "output",
            "owner": "f381bb15718aa",
            "links": [
                "b045238c56e6d",
                "72922c70d7656"
            ],
            "$type": "dock-relay-output"
        },
        "05bb0144d6d3e": {
            "id": "05bb0144d6d3e",
            "type": "input",
            "owner": "a3935eab533fc",
            "links": [
                "36c233d8203f1"
            ],
            "$type": "dock-sound-input"
        },
        "d698c269c5104": {
            "id": "d698c269c5104",
            "type": "input",
            "owner": "58cd9f9f78e76",
            "links": [
                "ade16e51b231b"
            ],
            "$type": "dock-sound-input"
        },
        "40bc67a721131": {
            "id": "40bc67a721131",
            "type": "input",
            "owner": "deb0fb2bdf7d4",
            "links": [
                "f2c00f25c4867"
            ],
            "$type": "dock-sound-input"
        },
        "c3a914bb4b8e": {
            "id": "c3a914bb4b8e",
            "type": "input",
            "owner": "804ef13aae202",
            "links": [
                "d56ee50944f89"
            ],
            "$type": "dock-sound-input"
        },
        "b3e859e01f3b6": {
            "id": "b3e859e01f3b6",
            "type": "input",
            "owner": "4f48fef9dc9fb",
            "links": [
                "b54c9931db49d"
            ],
            "$type": "dock-sound-input"
        },
        "4a61797d7ca5e": {
            "id": "4a61797d7ca5e",
            "type": "output",
            "owner": "498dca0690fed",
            "links": [
                "daba81b2ac665"
            ],
            "$type": "dock-output-pulse-output"
        },
        "8659582adcb46": {
            "id": "8659582adcb46",
            "type": "input",
            "owner": "03074c67d0978",
            "links": [
                "b045238c56e6d"
            ],
            "$type": "dock-relay-input"
        },
        "b6b647d4ab603": {
            "id": "b6b647d4ab603",
            "type": "output",
            "owner": "03074c67d0978",
            "links": [
                "c921038b6a18f",
                "0e50b65be1a8b"
            ],
            "$type": "dock-relay-output"
        },
        "5cf29ab445a47": {
            "id": "5cf29ab445a47",
            "type": "input",
            "owner": "c4043dab5cfba",
            "links": [
                "e48028be66b55"
            ],
            "$type": "dock-sound-input"
        },
        "27f6664bb2255": {
            "id": "27f6664bb2255",
            "type": "input",
            "owner": "f2053a7d0b396",
            "links": [
                "b3fa07c723451"
            ],
            "$type": "dock-relay-input"
        },
        "eb76a6f98b51d": {
            "id": "eb76a6f98b51d",
            "type": "output",
            "owner": "f2053a7d0b396",
            "links": [
                "36c233d8203f1"
            ],
            "$type": "dock-relay-output"
        },
        "aab783678826c": {
            "id": "aab783678826c",
            "type": "input",
            "owner": "0441e563f318a",
            "links": [
                "a0787676b6cc8"
            ],
            "$type": "dock-relay-input"
        },
        "1f0fb08f7a4bc": {
            "id": "1f0fb08f7a4bc",
            "type": "output",
            "owner": "0441e563f318a",
            "links": [
                "ade16e51b231b"
            ],
            "$type": "dock-relay-output"
        },
        "2fb599b757e6": {
            "id": "2fb599b757e6",
            "type": "input",
            "owner": "d052ea558cc4e",
            "links": [
                "34ff9e72cd016"
            ],
            "$type": "dock-relay-input"
        },
        "d5216ce904697": {
            "id": "d5216ce904697",
            "type": "output",
            "owner": "d052ea558cc4e",
            "links": [
                "f2c00f25c4867"
            ],
            "$type": "dock-relay-output"
        },
        "f6cdc3e77c8fa": {
            "id": "f6cdc3e77c8fa",
            "type": "input",
            "owner": "a90631dbff0e8",
            "links": [
                "7e0625d5030f3"
            ],
            "$type": "dock-relay-input"
        },
        "b234572956dbd": {
            "id": "b234572956dbd",
            "type": "output",
            "owner": "a90631dbff0e8",
            "links": [
                "d56ee50944f89"
            ],
            "$type": "dock-relay-output"
        },
        "cbd997a1d7f9c": {
            "id": "cbd997a1d7f9c",
            "type": "input",
            "owner": "da590f5558ee2",
            "links": [
                "72922c70d7656"
            ],
            "$type": "dock-relay-input"
        },
        "bb2cd7b3e6812": {
            "id": "bb2cd7b3e6812",
            "type": "output",
            "owner": "da590f5558ee2",
            "links": [
                "b54c9931db49d"
            ],
            "$type": "dock-relay-output"
        },
        "393be4b09c19b": {
            "id": "393be4b09c19b",
            "type": "input",
            "owner": "692846d2a0d3c",
            "links": [
                "c921038b6a18f"
            ],
            "$type": "dock-relay-input"
        },
        "3943cbb442a3d": {
            "id": "3943cbb442a3d",
            "type": "output",
            "owner": "692846d2a0d3c",
            "links": [
                "e48028be66b55"
            ],
            "$type": "dock-relay-output"
        },
        "65a73684139e8": {
            "id": "65a73684139e8",
            "type": "input",
            "owner": "dfb7ea3ae7cf2",
            "links": [
                "0e50b65be1a8b"
            ],
            "$type": "dock-relay-input"
        },
        "a7635a600850d": {
            "id": "a7635a600850d",
            "type": "output",
            "owner": "dfb7ea3ae7cf2",
            "links": [
                "4ab2e7d1a5fc7",
                "f136316ba8852"
            ],
            "$type": "dock-relay-output"
        },
        "cf42ff6f2ce6d": {
            "id": "cf42ff6f2ce6d",
            "type": "input",
            "owner": "72746e72fb4b2",
            "links": [
                "f136316ba8852"
            ],
            "$type": "dock-relay-input"
        },
        "844b11297c186": {
            "id": "844b11297c186",
            "type": "output",
            "owner": "72746e72fb4b2",
            "links": [
                "ba07c7e35b09b"
            ],
            "$type": "dock-relay-output"
        },
        "fc0af6146be49": {
            "id": "fc0af6146be49",
            "type": "input",
            "owner": "7d8be5d948a9",
            "links": [
                "3cd047876d7e7"
            ],
            "$type": "dock-relay-input"
        },
        "6d250fc6b7a14": {
            "id": "6d250fc6b7a14",
            "type": "output",
            "owner": "7d8be5d948a9",
            "links": [
                "aa120ccedf199"
            ],
            "$type": "dock-relay-output"
        },
        "88f0cf30bc5ac": {
            "id": "88f0cf30bc5ac",
            "type": "input",
            "owner": "675bddddbc778",
            "links": [
                "4ab2e7d1a5fc7"
            ],
            "$type": "dock-relay-input"
        },
        "01756de81c7b3": {
            "id": "01756de81c7b3",
            "type": "output",
            "owner": "675bddddbc778",
            "links": [
                "69129410c7ecc",
                "3cd047876d7e7"
            ],
            "$type": "dock-relay-output"
        },
        "6c65701497e65": {
            "id": "6c65701497e65",
            "type": "input",
            "owner": "f4109dfe5c6b6",
            "links": [
                "aa120ccedf199"
            ],
            "$type": "dock-sound-input"
        },
        "5cb94f8999dcc": {
            "id": "5cb94f8999dcc",
            "type": "input",
            "owner": "24e5b918987e5",
            "links": [
                "ba07c7e35b09b"
            ],
            "$type": "dock-sound-input"
        },
        "dd52414a1d17f": {
            "id": "dd52414a1d17f",
            "type": "input",
            "owner": "181357c349a6f",
            "links": [
                "eeac49fd7315e"
            ],
            "$type": "dock-sound-input"
        },
        "1343cdac0573": {
            "id": "1343cdac0573",
            "type": "input",
            "owner": "b5e6a327fc03e",
            "links": [
                "777a21753862c"
            ],
            "$type": "dock-relay-input"
        },
        "355b7c7c17c77": {
            "id": "355b7c7c17c77",
            "type": "output",
            "owner": "b5e6a327fc03e",
            "links": [
                "eeac49fd7315e"
            ],
            "$type": "dock-relay-output"
        },
        "09c52312f1787": {
            "id": "09c52312f1787",
            "type": "input",
            "owner": "cb72dcd168404",
            "links": [
                "69129410c7ecc"
            ],
            "$type": "dock-relay-input"
        },
        "aa038e2c40a01": {
            "id": "aa038e2c40a01",
            "type": "output",
            "owner": "cb72dcd168404",
            "links": [
                "777a21753862c",
                "bd7461ed151c"
            ],
            "$type": "dock-relay-output"
        },
        "8a527d9dd8359": {
            "id": "8a527d9dd8359",
            "type": "input",
            "owner": "93b300a5d078a",
            "links": [
                "83d80dea2fbbb"
            ],
            "$type": "dock-and-input1"
        },
        "191696fbd1218": {
            "id": "191696fbd1218",
            "type": "input",
            "owner": "93b300a5d078a",
            "links": [
                "bd7461ed151c"
            ],
            "$type": "dock-and-input2"
        },
        "d84dca9612d0a": {
            "id": "d84dca9612d0a",
            "type": "output",
            "owner": "93b300a5d078a",
            "links": [
                "9d0149678c7ec"
            ],
            "$type": "dock-and-output"
        },
        "a671c50c09fb3": {
            "id": "a671c50c09fb3",
            "type": "output",
            "owner": "c6b4d19b2b82c",
            "links": [
                "83d80dea2fbbb"
            ],
            "$type": "dock-output-output"
        }
    },
    "links": {
        "8c09edf7806eb": {
            "id": "8c09edf7806eb",
            "input": "337bebc239f86",
            "output": "2d68c2bd86a7f"
        },
        "f3ca871321591": {
            "id": "f3ca871321591",
            "input": "8aa76b8295232",
            "output": "d2bbaeb180a09"
        },
        "471ed071bb0a9": {
            "id": "471ed071bb0a9",
            "input": "8e0ee94fbb332",
            "output": "aa3c0f8bc602a"
        },
        "f47bb8815f6b3": {
            "id": "f47bb8815f6b3",
            "input": "a64320de414c1",
            "output": "4f4d8d1f20491"
        },
        "daba81b2ac665": {
            "id": "daba81b2ac665",
            "input": "4a61797d7ca5e",
            "output": "5c8dcf6dd28d"
        },
        "b045238c56e6d": {
            "id": "b045238c56e6d",
            "input": "54518073d26eb",
            "output": "8659582adcb46"
        },
        "b3fa07c723451": {
            "id": "b3fa07c723451",
            "input": "a64320de414c1",
            "output": "27f6664bb2255"
        },
        "36c233d8203f1": {
            "id": "36c233d8203f1",
            "input": "eb76a6f98b51d",
            "output": "05bb0144d6d3e"
        },
        "ade16e51b231b": {
            "id": "ade16e51b231b",
            "input": "1f0fb08f7a4bc",
            "output": "d698c269c5104"
        },
        "a0787676b6cc8": {
            "id": "a0787676b6cc8",
            "input": "8e0ee94fbb332",
            "output": "aab783678826c"
        },
        "34ff9e72cd016": {
            "id": "34ff9e72cd016",
            "input": "8aa76b8295232",
            "output": "2fb599b757e6"
        },
        "7e0625d5030f3": {
            "id": "7e0625d5030f3",
            "input": "337bebc239f86",
            "output": "f6cdc3e77c8fa"
        },
        "72922c70d7656": {
            "id": "72922c70d7656",
            "input": "54518073d26eb",
            "output": "cbd997a1d7f9c"
        },
        "c921038b6a18f": {
            "id": "c921038b6a18f",
            "input": "b6b647d4ab603",
            "output": "393be4b09c19b"
        },
        "e48028be66b55": {
            "id": "e48028be66b55",
            "input": "3943cbb442a3d",
            "output": "5cf29ab445a47"
        },
        "b54c9931db49d": {
            "id": "b54c9931db49d",
            "input": "bb2cd7b3e6812",
            "output": "b3e859e01f3b6"
        },
        "d56ee50944f89": {
            "id": "d56ee50944f89",
            "input": "b234572956dbd",
            "output": "c3a914bb4b8e"
        },
        "f2c00f25c4867": {
            "id": "f2c00f25c4867",
            "input": "d5216ce904697",
            "output": "40bc67a721131"
        },
        "69129410c7ecc": {
            "id": "69129410c7ecc",
            "input": "01756de81c7b3",
            "output": "09c52312f1787"
        },
        "4ab2e7d1a5fc7": {
            "id": "4ab2e7d1a5fc7",
            "input": "a7635a600850d",
            "output": "88f0cf30bc5ac"
        },
        "0e50b65be1a8b": {
            "id": "0e50b65be1a8b",
            "input": "b6b647d4ab603",
            "output": "65a73684139e8"
        },
        "f136316ba8852": {
            "id": "f136316ba8852",
            "input": "a7635a600850d",
            "output": "cf42ff6f2ce6d"
        },
        "3cd047876d7e7": {
            "id": "3cd047876d7e7",
            "input": "01756de81c7b3",
            "output": "fc0af6146be49"
        },
        "777a21753862c": {
            "id": "777a21753862c",
            "input": "aa038e2c40a01",
            "output": "1343cdac0573"
        },
        "ba07c7e35b09b": {
            "id": "ba07c7e35b09b",
            "input": "844b11297c186",
            "output": "5cb94f8999dcc"
        },
        "aa120ccedf199": {
            "id": "aa120ccedf199",
            "input": "6d250fc6b7a14",
            "output": "6c65701497e65"
        },
        "eeac49fd7315e": {
            "id": "eeac49fd7315e",
            "input": "355b7c7c17c77",
            "output": "dd52414a1d17f"
        },
        "bd7461ed151c": {
            "id": "bd7461ed151c",
            "input": "aa038e2c40a01",
            "output": "191696fbd1218"
        },
        "9d0149678c7ec": {
            "id": "9d0149678c7ec",
            "input": "d84dca9612d0a",
            "output": "5c8dcf6dd28d"
        },
        "83d80dea2fbbb": {
            "id": "83d80dea2fbbb",
            "input": "a671c50c09fb3",
            "output": "8a527d9dd8359"
        }
    },
    "options": {
        "panels": {
            "config": {
                "x": 548,
                "y": 74,
                "open": true
            }
        },
        "editorState": {
            "mode": "normal"
        },
        "global": {
            "timerInterval": 34,
            "lineStyle": "curved",
            "grided": true
        },
        "sound-item": {
            "channels": [
                {
                    "program": {
                        "id": "lead_5_charang",
                        "name": "Lead 5 (charang)",
                        "program": 84,
                        "category": "Synth Lead"
                    }
                },
                {
                    "program": {
                        "id": "acoustic_grand_piano",
                        "name": "Acoustic Grand Piano",
                        "program": 0,
                        "category": "Piano"
                    }
                },
                {
                    "program": {
                        "id": "acoustic_grand_piano",
                        "name": "Acoustic Grand Piano",
                        "program": 0,
                        "category": "Piano"
                    }
                },
                {
                    "program": {
                        "id": "acoustic_grand_piano",
                        "name": "Acoustic Grand Piano",
                        "program": 0,
                        "category": "Piano"
                    }
                },
                {
                    "program": {
                        "id": "acoustic_grand_piano",
                        "name": "Acoustic Grand Piano",
                        "program": 0,
                        "category": "Piano"
                    }
                },
                {
                    "program": {
                        "id": "acoustic_grand_piano",
                        "name": "Acoustic Grand Piano",
                        "program": 0,
                        "category": "Piano"
                    }
                },
                {
                    "program": {
                        "id": "acoustic_grand_piano",
                        "name": "Acoustic Grand Piano",
                        "program": 0,
                        "category": "Piano"
                    }
                },
                {
                    "program": {
                        "id": "acoustic_grand_piano",
                        "name": "Acoustic Grand Piano",
                        "program": 0,
                        "category": "Piano"
                    }
                },
                {
                    "program": {
                        "id": "acoustic_grand_piano",
                        "name": "Acoustic Grand Piano",
                        "program": 0,
                        "category": "Piano"
                    }
                },
                {
                    "program": {
                        "id": "acoustic_grand_piano",
                        "name": "Acoustic Grand Piano",
                        "program": 0,
                        "category": "Piano"
                    }
                },
                {
                    "program": {
                        "id": "acoustic_grand_piano",
                        "name": "Acoustic Grand Piano",
                        "program": 0,
                        "category": "Piano"
                    }
                },
                {
                    "program": {
                        "id": "acoustic_grand_piano",
                        "name": "Acoustic Grand Piano",
                        "program": 0,
                        "category": "Piano"
                    }
                },
                {
                    "program": {
                        "id": "acoustic_grand_piano",
                        "name": "Acoustic Grand Piano",
                        "program": 0,
                        "category": "Piano"
                    }
                },
                {
                    "program": {
                        "id": "acoustic_grand_piano",
                        "name": "Acoustic Grand Piano",
                        "program": 0,
                        "category": "Piano"
                    }
                },
                {
                    "program": {
                        "id": "acoustic_grand_piano",
                        "name": "Acoustic Grand Piano",
                        "program": 0,
                        "category": "Piano"
                    }
                },
                {
                    "program": {
                        "id": "acoustic_grand_piano",
                        "name": "Acoustic Grand Piano",
                        "program": 0,
                        "category": "Piano"
                    }
                }
            ]
        }
    }
}